module.exports = __webpack_public_path__ + "0ac7ea1429105c63a7d49d2b478eb5f3.MP3";